<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Verity Landon was born in 1985 in Surrey, where she has lived ever since. Soon after her birth, it became obvious to her parents that she had problems with her vision, but despite being registered visually impaired, she went to mainstream primary and secondary schools, where her love of writing soon became apparent. While still at school, she won two county competitions for short stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0373aa18